import { z } from 'zod'

/** UI languages. Swedish is the product's primary language and the fallback. */
export const SUPPORTED_LOCALES = ['sv', 'en'] as const
export const localeSchema = z.enum(SUPPORTED_LOCALES)
export type Locale = z.infer<typeof localeSchema>
export const DEFAULT_LOCALE: Locale = 'sv'

export function isLocale(value: unknown): value is Locale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value)
}
